import { Booking } from "app/_models/booking";
import { filtrosLaterais } from "app/_models/filtros-laterais";

export class MeusBookings {
  constructor(
    public FiltrosLateraisAtivos: filtrosLaterais,
    public Bookings: Booking[] = [],
    public DataFiltroIni: Date = null,
    public DataFiltroFim: Date = null
  ) {}
}
